import { marked } from 'marked';

export default function() {
  marked.setOptions({
    breaks: true
  });

  marked.use({
    renderer: {
      link({ href, title, text }) {
        const isApp = href?.startsWith('https://app.communityshare.org');
        if (isApp && href)
          href = href.replace('https://app.communityshare.org','')
        const isExternal = href?.startsWith('http://') || href?.startsWith('https://');
        const targetAttr = isExternal ? ' target="_blank" rel="noopener noreferrer"' : '';
        const titleAttr = title ? ` title="${title}"` : '';

        return `<a href="${href}"${targetAttr}${titleAttr}>${text}</a>`;
      }
    }
  });
};
